import { render, staticRenderFns } from "./FormTable.vue?vue&type=template&id=0dd7a428&"
import script from "./FormTable.vue?vue&type=script&lang=js&"
export * from "./FormTable.vue?vue&type=script&lang=js&"
import style0 from "./FormTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports